import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _get from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/get.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import User from "./User";
import Project from "./Project";
import GroupUser from "./GroupUser";
import ProjectGroup from "./ProjectGroup";

var Group = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Group, _VuexORM$Model);

  var _super = _createSuper(Group);

  function Group() {
    _classCallCheck(this, Group);

    return _super.apply(this, arguments);
  }

  _createClass(Group, [{
    key: "intermediate",
    value: function intermediate(key, entityId) {
      switch (key) {
        case 'project':
          return ProjectGroup.find([entityId, this.group_id]);

        case 'user':
          return GroupUser.find([this.group_id, entityId]);

        default:
          return null;
      }
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'groups';
    }
  }, {
    key: "apiConfig",
    get: function get() {
      return {
        dataKey: 'data'
      };
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'group_id';
    }
  }, {
    key: "insertOrUpdate",
    value: function insertOrUpdate(_ref) {
      var data = _ref.data;
      var isUserPivotIncluded = false,
          isProjectPivotIncluded = false;

      if (Array.isArray(data)) {
        data.forEach(function (item) {
          if (item.users && item.users.length) {
            isUserPivotIncluded = true;
          }

          if (item.projects && item.projects.length) {
            isProjectPivotIncluded = true;
          }
        });
        var userPivotData = [];

        if (isUserPivotIncluded) {
          // check if pivot table is present
          userPivotData = data.map(function (group) {
            return group.users.map(function (user) {
              return user.pivot;
            });
          }).flat();
        }

        var projectPivotData = [];

        if (isProjectPivotIncluded) {
          // check if pivot table is present
          projectPivotData = data.map(function (group) {
            return group.projects.map(function (project) {
              return project.pivot;
            });
          }).flat();
        }
      }

      return Promise.all([_get(_getPrototypeOf(Group), "insertOrUpdate", this).call(this, {
        data: data
      }), isUserPivotIncluded ? GroupUser.insertOrUpdate({
        data: userPivotData
      }) : Promise.resolve(), isProjectPivotIncluded ? ProjectGroup.insertOrUpdate({
        data: projectPivotData
      }) : Promise.resolve()]).then(function (results) {
        return results[0];
      });
    } // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.

  }, {
    key: "fields",
    value: function fields() {
      return {
        group_id: this.attr(null),
        name: this.attr(null),
        color: this.attr(null),
        users_count: this.attr(null),
        projects_count: this.attr(null),
        minutes_total: this.attr(null),
        minutes_billed: this.attr(null),
        minutes_billable: this.attr(null),
        cost_total: this.attr(null),
        cost_billed: this.attr(null),
        cost_billable: this.attr(null),
        revenue_total: this.attr(null),
        revenue_billed: this.attr(null),
        revenue_billable: this.attr(null),
        profit_total: this.attr(null),
        profit_billed: this.attr(null),
        profit_billable: this.attr(null),
        users: this.belongsToMany(User, GroupUser, 'group_id', 'user_id'),
        projects: this.belongsToMany(Project, ProjectGroup, 'group_id', 'project_id')
      };
    }
  }]);

  return Group;
}(VuexORM.Model);

_defineProperty(Group, "state", {
  pending: false,
  lastSync: null,
  count: 0
});

export { Group as default };